import type {
  VoucherEligibilityItem,
  VoucherGetByCodeResponse,
  VoucherGetEligibilitiesItem,
} from '@diamond/shared/types';
import type { Product } from '@diamond/shared/utils';

type VoucherDisplayItem =
  | VoucherEligibilityItem
  | VoucherGetByCodeResponse
  | VoucherGetEligibilitiesItem;

/**
 * Adds the ui_item_* fields (mirroring the upsold product) to promo-upsell
 * event params. Reused by the add-to-cart popup and the Product Detail Page.
 */
export function buildPromoUpsellParams(
  itemParams: Record<string, unknown>,
  product: Product | undefined
) {
  return {
    ...itemParams,
    ui_item_id: product?.item_code,
    ui_item_name: product?.title,
    ui_item_brand: product?.brand_name,
  };
}

/**
 * Adds ui_item_* fields and overrides voucher_id/voucher_name and
 * promotion_id/promotion_name to the "Voucher - ..." format for
 * voucher-upsell events. Reused by the add-to-cart popup and PDP.
 */
export function buildVoucherUpsellParams(
  itemParams: Record<string, unknown>,
  product: Product | undefined,
  voucher: VoucherDisplayItem
) {
  return {
    ...itemParams,
    ui_item_id: product?.item_code,
    ui_item_name: product?.title,
    ui_item_brand: product?.brand_name,
    voucher_id: voucher.code,
    voucher_name: voucher.title,
    promotion_id: `Voucher - ${product?.item_code} | ${voucher.title}`,
    promotion_name: `Voucher - ${voucher.title}`,
  };
}
